import React from 'react';
import { palette } from '../../styles/theme';

export function NotificationAnnouncementSVG ({ customStroke, className = '', size = 24, selected = false }) {
    const stroke = customStroke || palette.icons;
    return (
        <span className={className}>
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={'0 0 24 24'} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-notification">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                <path d="M10 6h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
                <path d="M17 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            </svg>
        </span>
    );
}
